<template>
    <div class="d-flex align-items-center mb-1">
        <div class="w-25">{{fieldType}}</div>
        <div class="w-75">

            <div class="w-100 btn-group border">
                <button type="button" class="btn btn-light dropdown-toggle text-left" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i v-if="selectedField" class="fal fa-xs text-secondary me-1 menu-icon" :class="getClass(selectedField)"> </i> {{selectedLabel}}
                </button>
                <div class="dropdown-menu w-100">
                    <a v-for="field in table.fields" class="dropdown-item" @click="onFieldSelected(field)" href="javascript:void(0)">
                        <i class="fal fa-xs text-secondary me-1 menu-icon" :class="getClass(field)"> </i>{{field.name}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FieldDropdownSelector',
        props: ['table', 'fieldType', 'fieldWrapper'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            selectedField() {

                if(this.fieldWrapper.field) {
                    let currentField = webase.utils.array.get(this.table.fields, this.fieldWrapper.field)
                    return currentField
                }

                return null
            },
            selectedLabel() {
                if(this.selectedField) {
                    return this.selectedField.name
                }

                return 'Select'
            }
        },
        mounted () {
        },
        methods: {
            onFieldSelected(field) {
                this.fieldWrapper.field = field.id
            },
            getClass(field) {
                return webase.utils.ui.getClass(field)
            }
        }
    }
</script>

<style>

</style>
